import GoogleMaps from "./google-maps";
import MapMyIndia from "./map-my-india";
import OlaMaps from "./ola-maps";
import { MAP_TYPE } from "../../constants/app-constants";

const Maps = (function () {
    let instance = null;

    return {
        getInstance(type) {
            if (!instance) {
                if (type === MAP_TYPE.MMI) {
                    instance = new MapMyIndia();
                } else if (type === MAP_TYPE.GOOGLE) {
                    instance = new GoogleMaps();
                } else if (type === MAP_TYPE.OLA) {
                    instance = new OlaMaps();
                }
            }
            return instance;
        }
    };
})();

export default Maps;
